// ButtonForm component
export default function (inputs = []) {
    let root;

    return {
        init() {
            root = this.$root;
            root.setAttribute('x-on:click.prevent', 'click');
        },

        click(event) {
            let action;

            if (root.tagName === 'A') {
                action = root.getAttribute('href');
                root.classList.add('disabled');
            } else {
                action = root.getAttribute('action');
                root.disabled = true;
            }

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = action;

            Object.assign(inputs, {
                _token: document.querySelector('meta[name="csrf-token"]')?.content ?? '',
                _method: root.getAttribute('method') ?? form.method,
            });

            for (const [name, value] of Object.entries(inputs)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.value = value;

                form.appendChild(input);
            }

            if (window.Bolt) {
                Bolt.preserveScroll(root.hasAttribute('bolt-preserve-scroll')).submitForm(form);
            } else {
                document.body.appendChild(form);
                form.submit();
            }
        },
    };
}
